<template>
	<div class="session1">
		<div class="bg disNone">
		</div>
	
		<div class="fixedTop">
			<div class="top">
				<h1>Live Chat</h1>
				<button :disabled="!isConnected" @click="fnCloseApp" type="button" class="top_closeBtn"><i class="iwp-icon-gen_close"></i></button>
			</div>
		</div>

		<!-- chat -->
		<div class="chat"> 
			<div ref="refChatContainer" @focus="pageFocused" class="chat-content">
				<template v-for="chatItem in chatItems" :key="chatItem.id">
					<template v-if="chatItem.you">
						<div ref="chatMessage" class="botChat">
							<div class="bot_img"><img src="../../public/images/botImage.png" alt=""></div>
							<div class="bot_content" style="float:left;">
								<div class="bot_name">{{ agentName }} 상담사</div><!--20220328 추가 -->
								<div class="bot_masage">
									<div class="left">
										<div>
											<span style="white-space: pre-line;">{{ chatItem.chatReceiveMsg }}</span>
											<template v-if="chatItem.fileData && chatItem.fileData.name.length > 0">
												<template v-if="chatItem.fileData.href">
													<p><img :src="chatItem.fileData.href" style="max-width:200px; margin:5px 0 5px 0;"></p>
												</template>
												<p style="display:block; text-align:right;"><a href="#" @click="onClickSaveFile(chatItem.fileData, $event)">저장</a></p>
											</template>
										</div>
									</div>
								</div>
								<template v-if="chatItem.smartCardList && chatItem.smartCardList.length > 0">
									<div class="bot_masage slick_demo_1" style="max-width:400px;">
										<carousel :items-to-show="1">
											<slide v-for="(cardList, index1) in chatItem.smartCardList" :key="cardList.id">
												<div class="selectCart">
													<ul>
														<template v-for="(card, index2) in cardList" :key="card.id">
															<li>
																<button style="" @click="onClickSmartCard({item: chatItem, row1: index1, row2: index2}, $event)" type="button" :class="{'btn1':true, 'active':card.selected}">
																	{{ card.title }}
																</button>
															</li>
														</template>
													</ul>
												</div>
											</slide>
											<template #addons="{ slidesCount }">
												<navigation v-if="slidesCount > 1" />
												<pagination />
											</template>
										</carousel>
									</div>
								</template>
							</div>
						</div>
						<div class="mgt5">
							<span class="bot_time">{{ chatItem.timeStamp }}</span>
						</div>
					</template>
					<template v-else-if="chatItem.me">
						<div ref="chatMessage" class="userChat">
							<div class="user_masage right">
								<div><span style="white-space: pre-line;">{{ chatItem.chatSendMsg }}</span></div>
								<template v-if="chatItem.fileData && chatItem.fileData.name.length > 0">
									<template v-if="chatItem.fileData.href">
										<p><img :src="chatItem.fileData.href" style="max-width:200px; margin:5px 0 5px 0;"></p>
									</template>
								</template>
							</div>
						</div>
						<div class="mgt5">
							<div class="user_time">{{ chatItem.timeStamp }}</div>
						</div>
					</template>
					<template v-else-if="chatItem.notice">
						<div ref="chatMessage" class="botChat">
							<div class="bot_msg">
								<span class="text-white" style="white-space: pre-line;">{{ chatItem.noticeMsg }}</span>
							</div>
						</div>
					</template>
					<template v-else-if="chatItem.exitGuide">
						<div class="botChat">
							<div class="bot_msg" style="background:#526482; text-align:center; padding:10px;  border-radius:8px;">
								<span class="text-white" style="font-size:13px; font-weight:300; white-space: pre-line;">{{ chatItem.noticeMsg }}</span>
								<span><button @click="fnCloseChat" type="button" class="btn1 mgt10">채팅 상담 종료하기</button></span>
							</div>
						</div>
					</template>
				</template>
			</div>
			<!-- //chat -->
		</div>
		<div class="bottomBar">
			<div class="inputBtn inputBtnLeft">
				<form action="upload" id="uploadForm" method="post" enctype="multipart/form-data">
					<input :disabled="!beginChat" type="file" name="file" id="file" v-bind:accept="attachFile.allowMimeType" @change="onFileChange" style="display:none"/>
				</form>
				<div onclick="document.all.file.click();" style="cursor:pointer">
					<i class="iwp-icon-ci_paperclip fs-xl"></i>
				</div>
			</div>
			<div class="searchInput">
				<input ref="refChatMsg" :disabled="!beginChat" v-model="chatMsg" @keyup.enter="fnSendMsg" type="text" title="질의어 입력하기" placeholder="질문을 입력해 주세요." class="chatInput">
				<!-- <textarea style="resize:none; width: 100%; height: 40px; border: 1px solid #cdcdcd; line-height: 38px; padding-left: 20px;" rows="1"  ref="refChatMsg" :disabled="!beginChat" v-model="chatMsg" @keyup.enter="fnSendMsg" type="text" title="질의어 입력하기" placeholder="질문을 입력해 주세요." class="chatInput"></textarea> -->
				<div @click="fnClearMsg" class="closeSearch"><i class="iwp-icon-gen_close_s fs-xl"></i></div>	
			</div>
			<div @click="fnSendMsg" class="inputBtn inputBtnRight" style="cursor:pointer">
				<i class="iwp-icon-ci_location fs-xl"></i>
			</div>
		</div>
		<!-- //bottom -->

	</div>
</template>

<script>
import moment from 'moment'
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

export default {
  name: 'ChatClient',
  props: {
    msg: String
  },
	components: {
		Carousel,
    Slide,
    Pagination,
    Navigation,
	},
  inject: ['innoLiveChatInitParam'],
	data () {
    return {
			agentName: null,
			uploadFile: null,
      isConnected: false,
			beginChat: false,
			chatItems: [],
      chatMsg: '',
      noticeMsg: '',
			index: 0,
			attachFile: {
				allowMimeType: '',
				limitSize: 0,
				limitSizeText: ''
			},
    }
  },
  mounted: function () {
		window.addEventListener('focus', this.pageFocused)
		window.document.body.addEventListener('focus', this.pageFocused)
		window.document.body.addEventListener('click', this.pageFocused)
		// console.log('innoLiveChatInitParam: ', this.innoLiveChatInitParam)
		// console.log('query.token: ', this.$route.query.token)
			// 		const chatItem = {
			// 	noticeMsg: '',
			// 	chatReceiveMsg: '계약 정보를 선택하세요.',
			// 	chatSendMsg: '',
			// 	id: this.index++,
			// 	me: false,
			// 	you: true,
			// 	notice: false,
			// 	smartCardList: [
			// 		[
			// 			{
			// 				"lonNo": "111111111111111",
			// 				"vhclNo": "11너1111",
			// 				"title": "11너1111",
			// 			},
			// 			{
			// 				"lonNo": "222222222222222",
			// 				"vhclNo": "22너2222",
			// 				"title": "22너2222",
			// 			},
			// 			{
			// 				"lonNo": "333333333333333",
			// 				"vhclNo": "33너3333",
			// 				"title": "33너3333",
			// 			},
			// 			{
			// 				"lonNo": "444444444444444",
			// 				"vhclNo": "44너4444",
			// 				"title": "44너4444",
			// 			}
			// 		],
			// 		[
			// 			{
			// 				"lonNo": "55555555555555",
			// 				"vhclNo": "55너5555",
			// 				"title": "55너5555",
			// 			}
			// 		]
			// 	],
			// 	timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
			// }
			// this.chatItems.push(chatItem)
  },
	watch: {
		isConnected: {
			handler: function(newVal) {
				if(!newVal) {
					this.fnNoticeMsg('연결이 종료 되었습니다.')
					this.beginChat = false
				}
			},
			deep: true
		},
		chatItems: {
			handler: function() {
				this.fnScrollToBottom()
			},
			deep: true
		}
	},
	sockets: {
		connect_error() {
			alert(`채팅 서버와 연결 할 수 없습니다.`)
		},
		connect_failed() {
			alert(`채팅 서버 연결 실패.`)
		},
		error(err) {
			alert(`채팅 오류: ${err.message || err}`)
		},
    connect() {
      // Fired when the socket connects.
      this.isConnected = true
    },
    disconnect() {
      this.isConnected = false
    },
		afi(data) {
			// console.log('afi data: ', data)
			this.attachFile.allowMimeType = data.allowMimeType
			this.attachFile.limitSize = data.limitSize
			this.attachFile.limitSizeText = data.limitSizeText
		},
    notice(data) {
			// this.noticeMsg = msg
			let exitGuide = false
			if(data.type) {
				if(data.type === 'beginChat') {
					this.beginChat = true
					this.agentName = data.agentName || '상담사'
				} else if(data.type === 'endChat') {
					this.beginChat = false
				} else if(data.type === 'exitGuide') {
					exitGuide = true
				}
			}
			const msg = (data.msg === undefined || data.msg === null) ? data : data.msg
			this.fnNoticeMsg(msg, exitGuide)
    },
		chatSmartCardMsg(smartCardList) {
			// console.log('smartCardList: ', smartCardList)
			const chatItem = {
				noticeMsg: '',
				chatReceiveMsg: '문의 하실 차량 번호를 선택해 주세요.',
				chatSendMsg: '',
				id: this.index++,
				me: false,
				you: true,
				notice: false,
				smartCardList: smartCardList,
				timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
			}
			this.chatItems.push(chatItem)
		},
		chatMsg(msg) {
			const chatItem = {
				noticeMsg: '',
				chatReceiveMsg: msg,
				chatSendMsg: '',
				id: this.index++,
				me: false,
				you: true,
				notice: false,
				smartCardList: [],
				timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
			}
			this.chatItems.push(chatItem)
		},
		// 파일을 상대방이 보냈음. 파일 정보를 수신하고 저장 여부를 선택한다.
		// 파일 저장을 선택하면 서버에 reqFileDownload 메시지를 보낸다.
		// 파일을 특정하기 위해서는 roomId 와 file 의 seqNo 가 필요하다.
		fileMsg(fileData) {
			// console.log('fileMsg data: ', fileData)
			const chatItem = {
				noticeMsg: '',
				chatReceiveMsg: fileData.name + ' 파일을 받았습니다.',
				chatSendMsg: '',
				id: this.index++,
				me: false,
				you: true,
				notice: false,
				fileData: fileData,
				timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
			}
			if(chatItem.fileData && chatItem.fileData.name && chatItem.fileData.type
				&& chatItem.fileData.type.toLowerCase().indexOf('image') === 0) {
				chatItem.fileData.href = this.getImageUrl(fileData)
			}
			this.chatItems.push(chatItem)
		}
  },
  methods: {
		pageFocused() {
			const chatInput = this.$refs.refChatMsg
			if(chatInput) {
				// console.log('focus to chat input')
				this.$refs.refChatMsg.focus()
			}
		},
		getImageUrl(fileData) {
			const blob = new Blob([fileData.data], { type: fileData.type })
			return URL.createObjectURL(blob)
			// fileData.href = href
			// return fileData.href
		},
		onClickSaveFile(fileData, event) {
			if (event) {
				event.preventDefault()
				// event.target.parentElement
			}
			const blob = new Blob([fileData.data], { type: fileData.type })
			const link = document.createElement('a')
			link.href = URL.createObjectURL(blob)
			link.download = fileData.name
			link.click()
			URL.revokeObjectURL(link.href)
		},
		onClickSmartCard(data, event) {
			if (event) {
				event.preventDefault()
				// event.target.parentElement
			}
			const chatItem = data.item
			const selectedCard = chatItem.smartCardList[data.row1][data.row2]
			// active class 변경
			for(const cardList of chatItem.smartCardList) {
				for(const card of cardList) {
					card.selected = false
				}
			}
			selectedCard.selected = true
			// 상담사에게 선택한 card 전송
			this.fnSendSelectedSmartCard(selectedCard)
		},
		fnSendSelectedSmartCard(selectedCard) {
			// this.$socket.emit('selectedSmartCardMsg', selectedCard)
			this.fnSendMsg(`선택하신 계약 정보는 ${selectedCard.title} 입니다.`)
		},
		fnNoticeMsg(msg, isExitGuide) {
			const chatItem = {
				noticeMsg: msg,
				chatReceiveMsg: '',
				chatSendMsg: '',
				id: this.index++,
				me: false,
				you: false,
				notice: isExitGuide ? false : true,
				exitGuide: isExitGuide,
				timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
			}
			this.chatItems.push(chatItem)
		},
		fnClearMsg() {
			this.chatMsg = ''
		},
		fnSendMsg(userMsg) {
			if(userMsg && userMsg.length > 0) {
				this.chatMsg = userMsg
			}
			if(this.chatMsg.length > 0) {
				this.chatMsg = this.chatMsg.replace(/\n\n$/, '\n');
				this.$socket.emit('chatMsg', this.chatMsg)
				const chatItem = {
					noticeMsg: '',
					chatReceiveMsg: '',
					chatSendMsg: this.chatMsg,
					id: this.index++,
					me: true,
					you: false,
					notice: false,
					timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
				}
				this.chatItems.push(chatItem)
				this.chatMsg = ''
			}
		},
		onFileChange(eventData) {
			// console.log('onFileChange: ', eventData.target.files[0])
			if(eventData && eventData.target && eventData.target.files && eventData.target.files.length > 0) {
				this.uploadFile = eventData.target.files[0]
				// 파일 유효성 검사
				if(this.uploadFile.size > this.attachFile.limitSize) {
					const msg = this.attachFile.limitSizeText + ' 크기 이하의 파일만 허용됩니다.'
					return alert(msg)
				} else {
					// console.log('uploadFile: ', this.uploadFile)
					window.document.body.style.cursor='wait';
					const fileData = {
						name: this.uploadFile.name,
						size: this.uploadFile.size,
						type: this.uploadFile.type,
						lastModified: this.uploadFile.lastModified,
						lastModifiedDate: this.uploadFile.lastModifiedDate,
						webkitRelativePath: this.uploadFile.webkitRelativePath,
						data:	this.uploadFile
					}
					this.$socket.emit('uploadFile', fileData, (ret, msg) => {
						if(ret === 'error') {
							this.fnNoticeMsg(msg)
						} else {
							const chatItem = {
								noticeMsg: '',
								chatReceiveMsg: '',
								chatSendMsg: this.uploadFile.name + ' 파일을 보냈습니다.',
								id: this.index++,
								me: true,
								you: false,
								notice: false,
								fileData: fileData,
								timeStamp: moment().locale('ko').format('LTS') //'MM/DD/YYYY hh:mm')
							}
							if(chatItem.fileData && chatItem.fileData.name && chatItem.fileData.type
								&& chatItem.fileData.type.toLowerCase().indexOf('image') === 0) {
								chatItem.fileData.href = this.getImageUrl(fileData)
							}
							this.chatItems.push(chatItem)
						}
						window.document.body.style.cursor='default';
					})
				}
			} else {
				this.uploadFile = null
			}
		},
		fnScrollToBottom() {
			if(this.chatItems.length < 2) {
				setTimeout(() => {
					// const elChatContainer = this.$refs.refChatContainer;
					// if(elChatContainer) {
					// 	elChatContainer.scrollTop = elChatContainer.scrollHeight - elChatContainer.clientHeight;
					// }
					window.scrollTo(0, 0);
				}, 10)
			} else {
				setTimeout(() => {
					// const elChatContainer = this.$refs.refChatContainer;
					// if(elChatContainer) {
					// 	elChatContainer.scrollTop = elChatContainer.scrollHeight - elChatContainer.clientHeight;
					// }
					window.scrollTo(0, document.body.scrollHeight);
					// $("#chatBoard").scrollTop($("#chatBoard")[0].scrollHeight);
				}, 10)
			}
		},
		fnCloseChat() {
				this.$socket.disconnect()
		},
		fnCloseApp() {
			const ret = confirm('상담을 종료 하시겠습니까?')
			if(ret) {
				this.fnNoticeMsg('상담이 종료 되었습니다.')
				this.$socket.disconnect()
				// document.getElementsByTagName ('html')[0].remove()
				// window.open('','_self').close()
			}
		},
	},
	updated() {
		// const elChatMessage = this.$refs.chatMessage;
		// // console.log('elChatMessage: ', elChatMessage)
		// if(elChatMessage && elChatMessage.length > 0) {
		// 	let el = elChatMessage.at(-1)
		// 	el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
		// }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.carousel__prev, .carousel__next {background-color: transparent !important;}
.carousel__pagination-item {display:none;}
.selectCart {padding:5px 25px 0 25px;}
.slick_demo_1 {margin-left:-25px;}
</style>
